import React, { useState } from "react";
import { Button, Stack, Text, SheetContainer, Divider } from "@bookingcom/bui-react";
import { useDSATraceabilityController, DSATraceabilityControllerProps } from "./useDSATraceability.controller";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline/index.js";

export function DSATraceabilityModal(props: DSATraceabilityControllerProps) {
  const { a11yClose, a11yTooltip, content, shouldRender, text, title } = useDSATraceabilityController(props);
  const [active, setActive] = useState(false);

  if (!shouldRender) return null;

  return (
    <>
      <Stack gap={2}>
        <Divider mixin={{ marginBlockStart: 2, marginBlockEnd: 0 }} />
        <Stack
          attributes={{ style: { display: "inline-flex" } }}
          gap={1}
          direction="row"
          alignItems="center"
          mixin={{ paddingBlockEnd: 8 }}
        >
          <Stack.Item>
            <Text variant="body_2">{text}</Text>
          </Stack.Item>
          <Stack.Item>
            <Button
              onClick={() => setActive(true)}
              attributes={{ "aria-label": a11yTooltip }}
              icon={QuestionMarkCircleIcon}
              variant="tertiary-neutral"
            />
          </Stack.Item>
        </Stack>
      </Stack>
      <SheetContainer
        title={title}
        closeAriaLabel={a11yClose}
        active={active}
        onClose={() => setActive(false)}
        onCloseTrigger={() => setActive(false)}
      >
        <Stack>
          {content.map((c) => (
            <Stack.Item key={c}>
              <Text variant="body_2">{c}</Text>
            </Stack.Item>
          ))}
        </Stack>
      </SheetContainer>
    </>
  );
}
